import Network from "@/common/network";
import {useSessionStore} from "../stores/session";

const HOOK_FUNC_NAME = {
    invalidSession: 'invalidSession',
};
const HOOK_FUNC = {};

export const register = (name, func) => HOOK_FUNC[name] = func;
export const unregister = name => delete HOOK_FUNC[name];

const API_COND = {
    invalidSession: {
        cond: response => response.data && response.data.code === Network.unauthorized.code,
        run: response => {
            const invalidSession = HOOK_FUNC[HOOK_FUNC_NAME.invalidSession];
            if (invalidSession) invalidSession(response);
            return true;
        },
    },
    other: {
        cond: ({data}) => data && data.code !== Network.noError.code,
    }
};

export const standard = [API_COND.invalidSession, API_COND.other];

export const apiError = async (response, hooks) => {
    const hook = hooks && hooks.find(({cond}) => cond(response));
    if (!hook) return false;
    hook.run && await hook.run(response);
    return true;
};

export default {
    install: (app, options) => {
        const pinia = app.config.globalProperties.$pinia;
        if (!pinia) {
            // Pinia가 먼저 설치되지 않은 경우 경고를 출력합니다.
            console.warn('⚠️ Pinia를 찾을 수 없습니다. myApiPlugin보다 먼저 Pinia를 설치해주세요.');
            return;
        }

        const sessionStore = useSessionStore(pinia);
        register(HOOK_FUNC_NAME.invalidSession, sessionStore.logout);
    },
}

